
import React, { useEffect, useState } from 'react'

type Props = {
    baseUrl?: string
    src: string
    onClick: () => void
    disabled?: boolean
}

const Avatar = (props: Props) => {

    const [ imageError, setImageError ] = useState(false)

    useEffect(() => {
        setImageError(false)
    }, [props.baseUrl, props.src])

    const hasImage = Boolean(props.src) && !imageError

    return (
        <div data-testid="avatar" className={`avatar ${props.disabled && 'disabled'}`} onClick={() => props.onClick()}>
            {hasImage ? (
                <img
                    src={`${props.baseUrl}/${props.src}`}
                    alt=""
                    onError={() => setImageError(true)}
                />
            ) : (
                <div className="text">
                    No Avatar
                </div>
            )}
        </div>
    )
}

export default Avatar
